/* RESPONSIBLE TEAM: team-frontend-tech */
// @ts-expect-error No type declarations
import HtmlCleaner from '@intercom/embercom-composer/lib/html-cleaner';

// @ts-expect-error Unused arguments
export default function (url: string, name?: string, options?: string) {
  let cleaner: { isJavascriptOrDataUri(uri: string): boolean } = new HtmlCleaner();

  if (cleaner.isJavascriptOrDataUri(url)) {
    console.error('Cannot open new window, URL is to a disallowed protocol.');
    return;
  }
  return window.open(...arguments); //eslint-disable-line @intercom/intercom/no-window-open
}
